<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-news infinite-list">

        <page-title :title="'Artykuły'" :back="true"></page-title>

        <news-segment></news-segment>

        <div v-for="(item,index) in news" :key="item.slug">
            <item-news
                    :index="index+1"
                    :route="{ name: 'NewsSingle', params: { slug: item.slug }}"
                    :slug="item.slug"
                    :badge="item.badge"
                    :title="item.title"
                    :subtitle="item.subtitle"
                    :image="item.image"
                    :date="item.created_at">
            </item-news>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import infiniteList from '@/mixins/infiniteList';
    import PageTitle from '@/components/PageTitle.vue';
    import ItemNews from '@/items/ItemNews';
    import NewsSegment from '@/navs/NewsSegment';

    export default {
        name: 'NewsIndex',
        mixins: [infiniteList],
        components: { PageTitle, ItemNews, NewsSegment },
        computed: {
            ...mapState({
                loading: state => state.news.loading,
                news: state => state.news.data,
                categories: state => state.global.categories.news
            })
        },
        created(){
            this.$root.$on('intiniteList', (payload) => {
                this.$store.dispatch('news/KNOWLEDGE_NEWS_SET_PAGE', false)
                this.getNews();
            });
        },
        beforeDestroy() {
            this.$root.$off("intiniteList");
        },
        mounted(){
            this.$store.dispatch('news/KNOWLEDGE_NEWS_SET_PAGE', true).then(() => {
                this.getNews();
            });
        },
        methods: {
            async getNews(){
                // fetch global news categories (id 1)
                if(!this.categories.length){
                    await this.$store.dispatch('GLOBAL_CATEGORIES_REQUEST', 1)
                }
                // dispatch news after category is set
                this.$store.dispatch('news/KNOWLEDGE_NEWS_REQUEST')
            }
        }
    }
</script>